// Libs
import React, { useEffect, useState } from "react";
import { generateID, KeyValuePair, useObserver, getHistory, useRouter } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { Button, Drawer, AppBar, List, Box, Typography, Paper, Link } from "@material-ui/core";
import { theme } from "Globals/Styles/AppTheme";
import styled from "styled-components";

// App
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "AppUrls";
import { Row } from "Globals/Styles/LayoutStyles";
import { ApplicantStatusEnum } from "Globals/Models/ApplicantStatusEnum";
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { PaymentModal } from "Views/Application/Modal/PaymentModal";
import { StyledLinkButton } from "Views/Admin/Applicants/Applicant/AdminApplicantView";
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
import DashboardApplicationViewModel from "Globals/ViewModels/Dashboard/DashboardApplicationViewModel";
import { ApplicationFormStatusEnum } from "Globals/Models";
const domainStores = StoresInstance.Domain;
interface IProps {
    paymentViewModel: PaymentViewModel;
    viewModel: DashboardApplicationViewModel;
    index: number;
}

export const ApplicationCardContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    p {
        font-size: 12px;
        font-weight: 600;
    }
`;

export const Application: React.FC<IProps> = (props: IProps) => {
    let status = domainStores.ApplicationFormStatusStore.getApplicationFormStatus().find((s) => s.id == props.viewModel.model.statusId);
    let rejectReason = domainStores.RejectReasonStore.getRejectReasons().find((s) => s.id == props.viewModel.model.rejectReasonId);
    const [viewModel] = useState(props.paymentViewModel);
    const [applicationFormViewModel] = useState(() => new ApplicationFormViewModel(props.viewModel.model.id ? props.viewModel.model.id : ""));
    const [adminApplicantViewModel] = useState(() => new AdminApplicantViewModel(props.viewModel.model.createdByUserId ? props.viewModel.model.createdByUserId : ""));
    const [modalStatus, setModalStatus] = useState(false);
    const { history, location, match } = useRouter();

    useEffect(() => {
        const handler = (event: any) => {
            const data = event.data;
            if (data.resultCode === 0) {
                adminApplicantViewModel.updateApplicatStatus(ApplicantStatusEnum.ReservationFeePaid);
                applicationFormViewModel.updateApplicationFormStatus(ApplicationFormStatusEnum.ReservationPaid);
                if (applicationFormViewModel.model.id) {
                    adminApplicantViewModel.insertAllPay(applicationFormViewModel.model.id, 500);
                }
                history.push("/");
            }
        };

        window.addEventListener("message", handler);

        // clean up
        return () => window.removeEventListener("message", handler);
    }, []);

    const modals = () => (
        <>
            {modalStatus && (
                <PaymentModal
                    isActive={modalStatus}
                    paymentViewModel={viewModel}
                    adminApplicantViewModel={adminApplicantViewModel}
                    confirmClose={() => {
                        viewModel.handleGetPaymentToken();
                        setModalStatus(false);
                    }}
                    onCancel={() => setModalStatus(false)}
                />
            )}
        </>
    );

    const application = () => (
        <>
            <ApplicationCardContainer>
                <Box>
                    <Paper>
                        <Link component={RouterLink} to={AppUrls.Client.Application.replace(":applicationId?", props.viewModel.model.id ? props.viewModel.model.id : "")}>
                            <Box
                                paddingX="15px"
                                paddingY="15px"
                                flexDirection={"column"}
                                display={"flex"}
                                style={
                                    rejectReason
                                        ? { backgroundColor: "#F3D1D4", border: "solid 1px #DC3545" }
                                        : status?.type == ApplicationFormStatusEnum.ReservationPaid
                                            ? { backgroundColor: "#D6EDD5", border: "solid 1px ##3AAA35" }
                                            : {}
                                }
                            >
                                {props.viewModel.model.submittedDate ? (
                                    <>
                                        <Typography style={{ marginBottom: "8px" }} variant={"body1"}>
                                            Application submitted: &nbsp;{props.viewModel.submittedDate}
                                        </Typography>
                                        <Typography variant={"body1"}>
                                            Current status: &nbsp;{" "}
                                            <Typography
                                                component={"span"}
                                                style={{
                                                    fontSize: "12px",
                                                    display: "inline",
                                                    color: `${status?.color}`,
                                                }}
                                            >
                                                <span>
                                                    {props.viewModel.model.statusName}: {rejectReason?.name}
                                                </span>
                                            </Typography>
                                        </Typography>
                                    </>
                                ) : (
                                    <Typography variant={"body1"}>Application last saved: {props.viewModel.lastSaved}</Typography>
                                )}
                            </Box>
                        </Link>
                        {props.viewModel.model.applicantUserStatus.toLocaleLowerCase() === "pending reservation fee" &&
                            applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired && (
                                <>
                                    <Box paddingLeft="15px" paddingBottom="15px" paddingRight="15px">
                                        <StyledLinkButton
                                            fullWidth
                                            onClick={() => {
                                                viewModel.handleGetPaymentToken();
                                                setModalStatus(true);
                                            }}
                                            style={{ backgroundColor: "#84BB25" }}
                                        >
                                            Pay now
                                        </StyledLinkButton>
                                    </Box>
                                </>
                            )}
                    </Paper>
                </Box>
            </ApplicationCardContainer>
            {modals()}
        </>
    );

    return useObserver(() => application());
};
